var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-text",attrs:{"title":_vm.data.notes}},[_vm._v(" "+_vm._s(_vm.data.notes)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }